export const TOAST_SERVICE_INTERFACE = 'TOAST_SERVICE_INTERFACE';

export interface ToastServiceInterface {
    showToast(text: string, type: string, duration?: number): void;
}
